import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

/**
 * Inline error strip for forms — icon plus message, announced to screen readers.
 *
 * Renders nothing when there is no message, so it is safe to leave mounted.
 * `className` and `style` are applied to the strip, so callers can override
 * spacing (e.g. marginTop: 0).
 */
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "flex-start",
    padding: theme.spacing(1.25, 1.5),
    marginTop: theme.spacing(1),
    border: `1px solid ${theme.palette.error.light}`,
    backgroundColor: "rgba(211, 47, 47, 0.04)",
  },
  icon: {
    color: theme.palette.error.main,
    fontSize: 18,
    marginTop: 2,
    marginRight: theme.spacing(1),
    flexShrink: 0,
  },
  text: {
    color: theme.palette.error.main,
    textAlign: "left",
    fontSize: "0.85rem",
    lineHeight: 1.5,
  },
}));

export default function InlineError({ message, className = "", style }) {
  const classes = useStyles();

  if (!message) return null;

  return (
    <Box role="alert" className={`${classes.root} ${className}`} style={style}>
      <ErrorOutlineIcon className={classes.icon} />
      <Typography className={classes.text}>{message}</Typography>
    </Box>
  );
}
